// extracted by mini-css-extract-plugin
export default {"categories":"FilterCategories_categories__6+x4q","row":"FilterCategories_row__5NKs8","drag_handle":"FilterCategories_drag_handle__liEcf"};